const statuses = ['NONE', 'APPROVED', 'DECLINED', 'PENDING', 'UPLOADED'];

export default { statuses };
